import { type I18nLocale, t } from '@ardoq/i18n';
import type { ExportLabels } from '@ardoq/export';

export const getExportLabels = (i18nLocale: I18nLocale): ExportLabels => ({
  largeFileWarningTitle: t(
    i18nLocale,
    'views:export.largeFile.title',
    'Warning'
  ),
  largeFileWarningSubtitle: t(
    i18nLocale,
    'views:export.largeFile.subtitle',
    'This export will result in a very large file. This might create unexpected results.'
  ),
  exportFailedTitle: t(
    i18nLocale,
    'views:export.failed.title',
    'Export Failed'
  ),
  viewTooLargeSubtitle: t(
    i18nLocale,
    'views:export.failed.viewTooLarge',
    'The view is too large for export. Please try reducing the size of the view.'
  ),
  okButton: t(i18nLocale, 'views:export.button.ok', 'OK'),
  closeButton: t(i18nLocale, 'views:export.button.close', 'Close'),
  unableToGenerateTitle: format =>
    t(
      i18nLocale,
      'views:export.unableToGenerate.title',
      { format },
      'Unable to generate {{format}}'
    ),
  unableToGenerateMessage: format =>
    t(
      i18nLocale,
      'views:export.unableToGenerate.message',
      { format },
      'Try to generate the {{format}} again using a smaller data set. If the issue keeps happening, please contact customer support.'
    ),
  longExportToast: t(
    i18nLocale,
    'views:export.longExport.toast',
    "It can take some time to export this view. Please don't change the window zoom while the browser is working."
  ),
});
